/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef, useState } from "react";

import { requestCheckout, requestPortal } from "../../services/userService"

// reactstrap components
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, Button, Collapse } from "reactstrap";


import { useNavigate } from "react-router-dom";
// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";
import { useUserAuth } from "../../context/UserContext";
import { useLesson } from "../../hooks/lessonFramework";
import './Subcriptions.css';






const Subscriptions2 = () => {

  const plans = [
    {
      name: 'Basic',
      priceMonthly: 9.99,
      priceYearly: 7.99,
      description: 'Great for casual viewing',
      features: ['HD available', 'Watch on 1 screen at a time', 'Unlimited movies and TV shows'],
      missing: ['No offline downloads']
    },
    {
      name: 'Standard',
      priceMonthly: 14.99,
      priceYearly: 11.99,
      description: 'Perfect for families',
      features: ['Full HD available', 'Watch on 2 screens at a time', 'Unlimited movies and TV shows', 'Download on 2 devices'],
      popular: true
    },
    {
      name: 'Premium',
      priceMonthly: 19.99,
      priceYearly: 15.99,
      description: 'Best for movie lovers',
      features: ['Ultra HD available', 'Watch on 4 screens at a time', 'Unlimited movies and TV shows', 'Download on 6 devices']
    }
  ];

  const faqs = [
    {
      question: 'What is StreamVibe?',
      answer: 'StreamVibe is a streaming service that offers a wide variety of award-winning TV shows, movies, anime, documentaries, and more.'
    },
    {
      question: 'How much does StreamVibe cost?',
      answer: 'Plans range from $9.99 to $19.99 a month. No extra costs, no contracts.'
    },
    {
      question: 'Where can I watch?',
      answer: 'Sign in with your StreamVibe account to watch instantly on any internet-connected device.'
    },
    {
      question: 'How do I cancel?',
      answer: 'StreamVibe is flexible. You can cancel your account online anytime with no cancellation fees.'
    }
  ];



  const [billingYearly, setBillingYearly] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('Standard');
  const [faqOpen, setFaqOpen] = useState({});

  const toggleFaq = index => {
    setFaqOpen(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="select-plan-page bg-light">
      <header className="bg-white shadow-sm py-4">
        <Container className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <i className="fas fa-play-circle text-primary fs-3 me-2"></i>
            <h1 className="h4 fw-bold text-dark mb-0">StreamVibe</h1>
          </div>
          <a href="#" className="text-primary fw-medium">Sign In</a>
        </Container>
      </header>

      <main className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3">Choose the plan that's right for you</h2>
            <p className="text-muted">Watch all you want. Ad-free. Cancel anytime.</p>
          </div>

          <div className="d-flex justify-content-center mb-4 toggle-wrapper">
            <div className="toggle-bg p-2 rounded-pill d-flex align-items-center">
              <span className="px-3 small">Monthly</span>
              <div className="form-check form-switch mx-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={billingYearly}
                  onChange={() => setBillingYearly(!billingYearly)}
                />
              </div>
              <span className="px-3 small">
                Yearly <span className="text-primary">(Save 20%)</span>
              </span>
            </div>
          </div>

          <Row className="gy-4">
            {plans.map(plan => (
              <Col md="4" key={plan.name}>
                <Card
                  className={`plan-card border-2 ${selectedPlan === plan.name ? 'selected border-primary' : 'border-secondary'}`}
                >
                  <CardBody className="d-flex flex-column">
                    {plan.popular && (
                      <div className="position-absolute top-0 start-50 translate-middle-x bg-primary text-white small fw-bold py-1 px-3 rounded-pill mt-n3">
                        MOST POPULAR
                      </div>
                    )}
                    <h5 className="fw-bold text-dark">{plan.name}</h5>
                    <p className="text-muted">{plan.description}</p>

                    <div className="my-3">
                      <span className="h4 fw-bold text-dark">
                        ${billingYearly ? plan.priceYearly : plan.priceMonthly}
                      </span>
                      <span className="text-muted">/month</span>
                    </div>

                    <ul className="list-unstyled flex-grow-1 mb-4">
                      {plan.features.map((feat, idx) => (
                        <li key={idx} className="d-flex align-items-center mb-2">
                          <i className="fas fa-check text-success me-2"></i>
                          <span>{feat}</span>
                        </li>
                      ))}
                      {plan.missing?.map((miss, idx) => (
                        <li key={idx} className="d-flex align-items-center text-muted mb-2">
                          <i className="fas fa-times me-2"></i>
                          <span>{miss}</span>
                        </li>
                      ))}
                    </ul>

                    <Button
                      color={selectedPlan === plan.name ? 'primary' : 'light'}
                      onClick={() => setSelectedPlan(plan.name)}
                      className="fw-medium"
                    >
                      Select Plan
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="faq-section bg-white mt-5 p-4 rounded shadow-sm mx-auto" style={{ maxWidth: '800px' }}>
            <h4 className="fw-bold mb-4 text-dark">Frequently Asked Questions</h4>
            {faqs.map((faq, index) => (
              <div key={index} className="border-bottom pb-3 mb-3">
                <Button
                  color="link"
                  className="text-start w-100 text-dark fw-medium d-flex justify-content-between align-items-center"
                  onClick={() => toggleFaq(index)}
                >
                  <span>{faq.question}</span>
                  <i className={`fas ${faqOpen[index] ? 'fa-minus' : 'fa-plus'} text-secondary`}></i>
                </Button>
                <Collapse isOpen={faqOpen[index]}>
                  <p className="text-muted mt-2">{faq.answer}</p>
                </Collapse>
              </div>
            ))}
          </div>
        </Container>
      </main>

      <footer className="bg-white border-top py-4 mt-5">
        <Container className="text-center">
          <div className="d-flex justify-content-between flex-column flex-md-row align-items-center">
            <div className="mb-2 mb-md-0 d-flex align-items-center">
              <i className="fas fa-play-circle text-primary fs-4 me-2"></i>
              <span className="fw-bold text-dark">StreamVibe</span>
            </div>
            <div className="d-flex gap-3">
              <a href="#" className="text-muted small">Terms of Use</a>
              <a href="#" className="text-muted small">Privacy</a>
              <a href="#" className="text-muted small">Help Center</a>
              <a href="#" className="text-muted small">Contact Us</a>
            </div>
          </div>
          <div className="text-muted small mt-3">&copy; 2025 StreamVibe. All rights reserved.</div>
        </Container>
      </footer>
    </div>
  );
};

export default Subscriptions2;
